import { onSleep } from "../../../utils/default";
import HTTPCore from "../../http.core";

class ReportHttpService extends HTTPCore {
    constructor() {
        super({})
    }
    //==============================
    setOpenModalTokenExpired;
    setTokenExpiredHandler(handler) {
        this.setOpenModalTokenExpired = handler;
    }
    handleTokenExpiration(open) {
        if (this.setOpenModalTokenExpired) {
            this.setOpenModalTokenExpired(open);
        } else {
            console.error("Token expired handler not set");
        }
    }
    //==============================
    getEnv() {
        return process.env.REACT_APP_ENDPOINT_SAT;
    }
    getToken() {
        let token = "";
        token = localStorage.getItem("at") || "";
        return `bearer ${token}`;
    }
    getRefreshToken() {
        let token = "";
        token = localStorage.getItem("rt") || "";
        return `bearer ${token}`;
    }
    async handleRefreshToken() {
        let response = null;
        try {
            response = await this.refreshToken();
        } catch { }
        if (response) {
            localStorage.setItem("at", response.access_token)
            localStorage.setItem("rt", response.refresh_token)
        } else {
            this.handleTokenExpiration(true)
            await onSleep(2000);
            localStorage.clear();
            window.location.href = `${process.env.REACT_APP_BASE_PATH}/login`;
        }
        return response;
    }
    refreshToken() {
        let token = this.getRefreshToken();
        let url = this.getEnv();
        let path = `/user/refresh-token`
        let fullUrl = url + path
        return this.get(fullUrl, {
            headers: { Authorization: token }
        });
    }
    //==============================
    async listEvaluationReport(param) {
        const func = () => {
            let token = this.getToken();
            let url = this.getEnv();
            let path = `/report/evaluation-history/by-param`;
            let fullUrl = url + path;
            return this.post(fullUrl, param, {
                headers: { Authorization: token },
            });
        }
        let response = func();
        try {
            await response;
        } catch (err) {
            if (err?.response?.data?.status === 401) {
                const check = await this.handleRefreshToken();
                if (check) {
                    response = func();
                    return response;
                }
            }
            throw err;
        }
        return response;
    }
    async detailEvaluationReport(param) {
        const func = () => {
            let token = this.getToken();
            let url = this.getEnv();
            let path = `/report/evaluation-history/detail`;
            let fullUrl = url + path;
            return this.get(fullUrl, {
                headers: { Authorization: token },
                params: param,
            });
        }
        let response = func();
        try {
            await response;
        } catch (err) {
            if (err?.response?.data?.status === 401) {
                const check = await this.handleRefreshToken();
                if (check) {
                    response = func();
                    return response;
                }
            }
            throw err;
        }
        return response;
    }
    async exportEvaluationReport(param) {
        const func = () => {
            let token = this.getToken();
            let url = this.getEnv();
            let path = `/report/evaluation-history/export`;
            let fullUrl = url + path;
            return this.getAllResponse(fullUrl, {
                headers: { Authorization: token },
                params: param,
                responseType: "blob",
            });
        }
        let response = func();
        try {
            await response;
        } catch (err) {
            if (err?.response?.data?.status === 401) {
                const check = await this.handleRefreshToken();
                if (check) {
                    response = func();
                    return response;
                }
            }
            throw err;
        }
        return response;
    }
    async listTopEvaluators(param) {
        const func = () => {
            let token = this.getToken();
            let url = this.getEnv();
            let path = `/report/top-evaluators/by-param`;
            let fullUrl = url + path;
            return this.post(fullUrl, param, {
                headers: { Authorization: token },
            });
        }
        let response = func();
        try {
            await response;
        } catch (err) {
            if (err?.response?.data?.status === 401) {
                const check = await this.handleRefreshToken();
                if (check) {
                    response = func();
                    return response;
                }
            }
            throw err;
        }
        return response;
    }
    async exportTopEvaluators(param) {
        const func = () => {
            let token = this.getToken();
            let url = this.getEnv();
            let path = `/report/top-evaluators/export`;
            let fullUrl = url + path;
            return this.getAllResponse(fullUrl, {
                headers: { Authorization: token },
                params: param,
                responseType: "blob",
            });
        }
        let response = func();
        try {
            await response;
        } catch (err) {
            if (err?.response?.data?.status === 401) {
                const check = await this.handleRefreshToken();
                if (check) {
                    response = func();
                    return response;
                }
            }
            throw err;
        }
        return response;
    }
    async listRatingSummary(param) {
        const func = () => {
            let token = this.getToken();
            let url = this.getEnv();
            let path = `/report/rating-summary/by-param`;
            let fullUrl = url + path;
            return this.post(fullUrl, param, {
                headers: { Authorization: token },
            });
        }
        let response = func();
        try {
            await response;
        } catch (err) {
            if (err?.response?.data?.status === 401) {
                const check = await this.handleRefreshToken();
                if (check) {
                    response = func();
                    return response;
                }
            }
            throw err;
        }
        return response;
    }
    async exportRatingSummary(param) {
        const func = () => {
            let token = this.getToken();
            let url = this.getEnv();
            let path = `/report/rating-summary/export`;
            let fullUrl = url + path;
            return this.getAllResponse(fullUrl, {
                headers: { Authorization: token },
                params: param,
                responseType: "blob",
            });
        }
        let response = func();
        try {
            await response;
        } catch (err) {
            if (err?.response?.data?.status === 401) {
                const check = await this.handleRefreshToken();
                if (check) {
                    response = func();
                    return response;
                }
            }
            throw err;
        }
        return response;
    }
    async previewRatingSummaryPdf(param) {
        const func = () => {
            let token = this.getToken();
            let url = this.getEnv();
            let path = `/report/rating-summary/export-pdf/preview`;
            let fullUrl = url + path;
            return this.get(fullUrl, {
                headers: { Authorization: token },
                params: param,
            });
        }
        let response = func();
        try {
            await response;
        } catch (err) {
            if (err?.response?.data?.status === 401) {
                const check = await this.handleRefreshToken();
                if (check) {
                    response = func();
                    return response;
                }
            }
            throw err;
        }
        return response;
    }
    async exportRatingSummaryPdf(param) {
        const func = () => {
            let token = this.getToken();
            let url = this.getEnv();
            let path = `/report/rating-summary/export-pdf`;
            let fullUrl = url + path;
            return this.getAllResponse(fullUrl, {
                headers: { Authorization: token },
                params: param,
                responseType: "blob",
            });
        }
        let response = func();
        try {
            await response;
        } catch (err) {
            if (err?.response?.data?.status === 401) {
                const check = await this.handleRefreshToken();
                if (check) {
                    response = func();
                    return response;
                }
            }
            throw err;
        }
        return response;
    }
}

export {
    ReportHttpService,
};
